import { defaultService } from '../../services'
import { alertActions } from '../alert/alert.actions'
import { errorMessages } from '../../messages'
import { chempConstants, uriConstants } from '../../constants'


export const chempCertboxActions = {
  changeSearchInfo,
  readCertboxList,
  getcertboxInfo,
  settingHistory,
  getDownLoad,
}

/*******************
 method 반드시 이렇게..

 GET    = Read
 POST   = Create
 PUT    = Update
 DELETE = Delete
 ********************/

/*********
 수신함 검색조건 변경
 **********/
function changeSearchInfo(info) {
  return async (dispatch) => {
    dispatch(request(info))
  }
  function request(info) {
    return {
      type: chempConstants.SELECT_SEARCH_REQUEST,
      payload: info,
    }
  }
}

/*********
 내문서함/받은문서함(수신함) 리스트 조회
 **********/

function readCertboxList(params) {
  return async (dispatch) => {
    dispatch(request())

    const queryString = require('query-string')
    let paramStr = queryString.stringify(params)
    paramStr.length > 0 && (paramStr = '?' + paramStr)

    defaultService
      .handleService({
        method: 'get',
        endPoint: uriConstants.API_URI + uriConstants.GET_CHEMP_INBOX_LIST + paramStr,
      })
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
          dispatch(
            alertActions.error({
              title: null,
              message: errorMessages.systemError,
            }),
          )
        },
      )
  }

  function request() {
    return {
      type: chempConstants.CERTBOX_REQUEST,
    }
  }
  function success(response) {
    return {
      type: chempConstants.CERTBOX_SUCCESS,
      response,
    }
  }
  function failure(response) {
    return {
      type: chempConstants.CERTBOX_FAILURE,
      response,
    }
  }
}

/*********
 수신함 증명서 상세조회
 **********/

function getcertboxInfo(crtSeq) {
  return async (dispatch) => {
    dispatch(request())

    defaultService
      .handleService({
        method: 'get',
        endPoint: uriConstants.API_URI + uriConstants.GET_INBOX_INFO + '/' + crtSeq,
      })
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
          dispatch(apiError(error))
        },
      )
  }

  function request() {
    return {
      type: chempConstants.DETAIL_REQUEST,
    }
  }
  function success(response) {
    return {
      type: chempConstants.DETAIL_SUCCESS,
      response,
    }
  }
  function failure(response) {
    return {
      type: chempConstants.DETAIL_FAILURE,
      response,
    }
  }
}

/***********
 증명서 수신함 리스트 히스토리관리
 ************/
function settingHistory(history) {
  return async (dispatch) => {
    dispatch(request(history))
  }

  function request(history) {
    return {
      type: chempConstants.CERTBOX_HISTORY,
      payload: history,
    }
  }
}

function apiError(error) {
  return alertActions.error({
    title: null,
    message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError,
  })
}

/*********
 첨부파일 다운로드
 **********/
function getDownLoad(params) {
  return async (dispatch) => {
    dispatch(request())
    defaultService
      .handleService({
        method: 'put',
        endPoint: uriConstants.API_URI + uriConstants.EFDOC_DOWNLOAD,
        params: params,
      })
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
          dispatch(apiError(error))
        },
      )
  }

  function request() {
    return {
      type: chempConstants.FILE_DOWN_REQUEST,
    }
  }
  function success(response) {
    return {
      type: chempConstants.FILE_DOWN_SUCCESS,
      response,
    }
  }
  function failure(response) {
    return {
      type: chempConstants.FILE_DOWN_FAILURE,
      response,
    }
  }
}
